import { Navbar, Nav, NavItem, Button, Badge } from 'reactstrap'
import { NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { isRestricedUser as getIsRestrictedUser, canAccessAdmin as getCanAccessAdmin } from 'selectors/user'

import { setUniqueContractVisible } from 'actions/contractSelection'

const TopNav = ({ setUserPanelOpen, userPanelOpen }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const dispatch = useDispatch()
  const isRestricted = useSelector(getIsRestrictedUser)
  const canAccessAdmin = useSelector(getCanAccessAdmin)

  return (
    <Navbar expand className="topNav">
      <Nav navbar>
        {paths
        .filter(i => !(isRestricted && i.hideWhenRestricted))
        .map((i, index) => (
          <NavItem key={index}>
            <NavLink
              to={i.dir + i.link}
              activeClassName="active"
              className="nav-link"
              onClick={() => {
                dispatch(setUniqueContractVisible(null))
              }}
              isActive={() =>
                (i.dir && location.pathname.match('^' + i.dir)) ||
                location.pathname.match('^' + i.link)
              }
            >
              <span >
                <i style={{ color: '#0082f3cc' }} className={i.icon} /> {t(i.text)} {i.nb && <Badge>{i.nb}</Badge>}
              </span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <Nav className="ml-auto" navbar >
        { canAccessAdmin && 
          pathsAdmin
          .filter(i => !(isRestricted && i.hideWhenRestricted))
          .map((i, index) => (
            <NavItem key={index}>
              <NavLink
                to={i.dir + i.link}
                activeClassName="active"
                className="nav-link"
                onClick={() => {
                  dispatch(setUniqueContractVisible(null))
                }}
                isActive={() =>
                  (i.dir && location.pathname.match('^' + i.dir)) ||
                  location.pathname.match('^' + i.link) ||
                  location.pathname.match('^/transactions')
                }
              >
                <span>
                  <i className={i.icon} /> {t(i.text)} {i.nb && <Badge>{i.nb}</Badge>}
                </span>
              </NavLink>
            </NavItem>
          ))}
        <NavItem className="menu-user"  >
          <Button color="link" title="" onClick={() => setUserPanelOpen(!userPanelOpen)} style={{ color: '#528ff4'}}>
            <i className="icon-user" />
            <i className="icon-smallarrow-down" />
          </Button>
        </NavItem>
      </Nav>
    </Navbar>
  )
}

export default TopNav

export const paths = [
  {
    text: 'topNav.execution',
    icon: 'icon-diag',
    dir: '',
    link: '/exec',
  },
  {
    text: 'topNav.market',
    icon: 'icon-ccourbes',
    dir: '',
    link: '/market',
    hideWhenRestricted: true
  },
  {
    text: 'topNav.strategy',
    icon: 'icon-ic-diagram',
    dir: '',
    link: '/strategy',
    hideWhenRestricted: true
  },
  {
    text: 'topNav.deals',
    icon: 'icon-vallet',
    dir: '',
    link: '/deals',
  },
  {
    text: 'topNav.alerts',
    icon: 'icon-ic-notif',
    dir: '',
    link: '/alerts',
  },
  {
    text: 'topNav.documents',
    icon: 'icon-ion-document',
    dir: '',
    link: '/documents',
  },
]

export const pathsAdmin = [
  {
    text: 'topNav.administration',
    icon: 'icon-coche-check',
    dir: '',
    link: '/admin',
    hideWhenRestricted: true
  },
]
